import { useState, useCallback } from 'react';

export const useAttachments = () => {
  const [attachments, setAttachments] = useState({
    images: [],
    protocol: null,
    biohacks: [],
    biomarker: null,
    protocolReport: null
  });

  const addImages = useCallback((newImages) => {
    setAttachments(prev => {
      // If a protocol report is already selected, don't allow adding other attachments
      if (prev.protocolReport) {
        return prev;
      }
      return {
        ...prev,
        images: [...prev.images, ...newImages]
      };
    });
  }, []);

  const addProtocol = useCallback((protocol) => {
    setAttachments(prev => {
      // If a protocol report is already selected, don't allow adding other attachments
      if (prev.protocolReport) {
        return prev;
      }
      return { ...prev, protocol };
    });
  }, []);

  const addBiohacks = useCallback((biohacks) => {
    setAttachments(prev => {
      // If a protocol report is already selected, don't allow adding other attachments
      if (prev.protocolReport) {
        return prev;
      }
      return { ...prev, biohacks };
    });
  }, []);

  const addBiomarker = useCallback((biomarker) => {
    setAttachments(prev => {
      // If a protocol report is already selected, don't allow adding other attachments
      if (prev.protocolReport) {
        return prev;
      }
      return { ...prev, biomarker };
    });
  }, []);

  const addProtocolReport = useCallback((protocolReport) => {
    setAttachments(prev => {
      // When adding a protocol report, clear all other attachments
      return {
        images: [],
        protocol: null,
        biohacks: [],
        biomarker: null,
        protocolReport: protocolReport
      };
    });
  }, []);

  const removeAttachment = useCallback((type, id) => {
    if (type === 'image') {
      setAttachments(prev => ({
        ...prev,
        images: prev.images.filter(img => img.id !== id)
      }));
    } else if (type === 'protocol') {
      setAttachments(prev => ({ ...prev, protocol: null }));
    } else if (type === 'biohacks') {
      setAttachments(prev => ({ ...prev, biohacks: [] }));
    } else if (type === 'biomarker') {
      setAttachments(prev => ({ ...prev, biomarker: null }));
    } else if (type === 'protocolReport') {
      setAttachments(prev => ({ ...prev, protocolReport: null }));
    }
  }, []);

  const resetAttachments = useCallback(() => {
    setAttachments({ images: [], protocol: null, biohacks: [], biomarker: null, protocolReport: null });
  }, []);

  return {
    attachments,
    addImages,
    addProtocol,
    addBiohacks,
    addBiomarker,
    addProtocolReport,
    removeAttachment,
    resetAttachments
  };
};
